import React, { memo } from "react";

const HomeIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M1 16.5V5.83333L7.93333 0.5L14.8667 5.83333V16.5H9.66667V10.2778H6.2V16.5H1Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { HomeIcon };
